import { render, staticRenderFns } from "./center.vue?vue&type=template&id=2425a1c4&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&id=2425a1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2425a1c4",
  null
  
)

component.options.__file = "center.vue"
export default component.exports